<template>
    <div class="content view-wrapper">
        <div class="user-top">
            <div class="img">
                <img src="../assets/image/head.png" alt />
            </div>
            <div class="name">
                <span v-if="mobile === ''">
                    <router-link to="/login">登录/注册</router-link>
                </span>
                <span v-else>{{ mobile }}</span>
            </div>
        </div>
        <van-row class="user-links">
            <van-col span="8">
                <router-link to="/order/1">
                    <van-icon name="pending-payment" />待付款
                </router-link>
            </van-col>
            <van-col span="8">
                <router-link to="/order/2">
                    <van-icon name="tosend" />待发货
                </router-link>
            </van-col>
            <van-col span="8">
                <router-link to="/order/5">
                    <van-icon name="completed" />已完成
                </router-link>
            </van-col>
        </van-row>

        <van-cell-group class="user-group">
            <van-cell icon="records" title="全部订单" is-link to="/order/0" />
        </van-cell-group>

        <van-cell-group>
            <van-cell icon="user-o" title="账号与安全" is-link to="/account" />
            <van-cell icon="coupon-o" title="新影联票卡 " is-link to="/coupons" />
            <van-cell
                icon="location-o"
                title="地址管理"
                is-link
                to="/address?type=manage"
            />
            <van-cell icon="service-o" title="客服电话" value="400-6870707" />
        </van-cell-group>
        <div  v-if="mobile !== ''" style="text-align:center;padding:0 15px;margin-top:40px;">
            <van-button plain block type="warning" @click="loginOut">退出登录</van-button>
        </div>
        <Tabbar></Tabbar>
    </div>
</template>

<script>
import {mapActions} from "vuex";
import Tabbar from "@/components/Tabbar.vue";
export default {
    components: {
        Tabbar,
    },
    data() {
        return {
            name: "dd",
        };
    },
    computed: {
        mobile() {
            if (this.$store.state.user)
                return this.$store.state.user.Mobile || "";
            else {
                return "";
            }
        },
    },
    activated() {
        //console.log(this.$store.state.user);
    },
    methods: {
        ...mapActions(["loginOut"]),
    },
};
</script>

<style lang="less" scoped>
.user {
    &-top {
        padding: 30px 0;
        display: flex;
        align-items: center;
        background-color: #fd2d2d;
    }
    &-top .img {
        margin: 0 20px 0 30px;
        height: 60px;
        width: 60px;
        border-radius: 100%;
        overflow: hidden;
        text-align: center;
        border: 2px solid hsla(0, 0%, 100%, 0.4);
    }
    &-top .img img {
        width: auto;
        height: 100%;
        margin: 0 auto;
    }
    &-top .name {
        color: #fff;
        text-align: center;
    }
    &-top .name a {
        color: #fff;
    }
    &-poster {
        width: 100%;
        height: 53vw;
        display: block;
    }
    &-group {
        margin-bottom: 15px;
    }
    &-links {
        padding: 15px 0;
        font-size: 12px;
        text-align: center;
        background-color: #fff;
        .van-icon {
            display: block;
            font-size: 24px;
        }
    }
}
</style>
